import React from "react";
import { motion } from "framer-motion";

const AvailableFormats = () => {
  return (
    <div className="bg-gradient-to-b from-black via-green-900 to-green-800 text-white py-16 px-5">
      <div className="max-w-7xl mx-auto text-center">
        {/* Title Section */}
        <motion.h2
          className="text-white text-5xl font-extrabold mb-6"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          AVAILABLE FORMATS
        </motion.h2>
        <motion.p
          className="text-gray-400 mb-12 text-lg"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Discover our Animal Sorbet Kush Mints available in a range of formats.
        </motion.p>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {[
            {
              img: "/images/Formats/Eighth.jpg",
              title: "Eighth / Half Quarter",
              description: "Beyond Bloom",
            },
            {
              img: "/images/Formats/Blunt.png",
              title: "Blunt (1 x 1G)",
              description: "Beyond Bloom",
            },
            {
              img: "/images/Formats/Pre-Roll.png",
              title: "Pre-Roll Pack",
              description: "Beyond Bloom",
            },
          ].map((card, index) => (
            <motion.div
              key={index}
              className="group relative bg-gradient-to-br from-gray-800 via-gray-900 to-black rounded-lg shadow-lg hover:shadow-2xl overflow-hidden transition-all duration-300 transform"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              transition={{
                opacity: { duration: 0.6 },
                scale: { duration: 0.3 },
              }}
            >
              <motion.div className="relative overflow-hidden">
                <motion.img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-48 object-cover rounded-t-lg transition-transform duration-500 group-hover:scale-110"
                />
              </motion.div>
              <div className="p-6 text-center">
                <motion.h3
                  className="text-xl font-bold uppercase mb-2 transition-colors duration-300 group-hover:text-orange-400"
                >
                  {card.title}
                </motion.h3>
                <motion.p
                  className="text-gray-300 transition-colors duration-300 group-hover:text-gray-200"
                >
                  {card.description}
                </motion.p>
              </div>
              <motion.div
                className="absolute inset-0 border border-transparent group-hover:border-orange-400 transition-all duration-300 rounded-lg"
              ></motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvailableFormats;
